export default __webpack_public_path__ + "static/media/newContract.f7b1646a.svg";